import { UrlParams } from "@/utils/urlParams";

const PromoCodeOffer = () => {
    const params = new URLSearchParams(window ? window.location.search : {});
    const promoCode = params.get(UrlParams.PROMO);
    if (promoCode) {
        return (
            <div className="h-fit bg-black py-3 text-center text-zing-16-22 text-white">
                <div>🎁 EXCLUSIVE OFFER:</div>
                <div>
                    Use code{" "}
                    <span className="font-bold uppercase text-zing-warm-tangerine-500">
                        {promoCode}
                    </span>{" "}
                    for 70% off at checkout
                </div>
                <div>Complete quiz to unlock</div>
            </div>
        );
    }
    return null;
};

export default PromoCodeOffer;
